import React, { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ActionLink } from '../../atoms';
import { UserContext } from '../../../context';

import { default as t } from '../../../utils/i18n';
import config from '../../../utils/config';
import { ReactComponent as EditIcon } from '../../../assets/svg/edit.svg';
import { ReactComponent as SaveIcon } from '../../../assets/svg/save.svg';
import './define-report-data.scss';
import { Paper, Step, StepContent, StepLabel, Stepper, Typography, makeStyles, styled } from '@material-ui/core';
import ChooseReportType from '../choose-report-type/choose-report-type';

import { ReactComponent as StepperBlueIcon } from '../../../assets/svg/stepper_blue_radio.svg';
import { ReactComponent as StepperBlueUnfilledIcon } from '../../../assets/svg/stepper_unfilled_radio.svg';
import { ReactComponent as StepperGroupIcon } from '../../../assets/svg/stepper_group.svg';
import ReportMetrics from '../report-metrics/report-metrics';
import ReportSummary from '../report-summary/report-summary';
import ChooseReportCampaigns from '../choose-report-campaigns/choose-report-campaigns';
import ReportBreakdownTable from '../report-breakdown-table/report-breakdown-table';
import { Button } from 'rsuite';
import { ReportsService } from '../../../services';

const HELP_SUPPORT_LINK = config.get('help', 'support_link');
const HELP_EMAIL_ID = config.get('help', 'support_email');
const HELP_LINK = config.get('help', 'support_url');

const DefineReportData = props => {
  const { user, setUser } = useContext(UserContext);
  const currentActiveStep = user?.activeStep > 0 ? user.activeStep : 0;
  const draftReportId = user?.draftReportId;
  const userReportName = user?.reportName;
  const type = user?.reportType;
  const history = useHistory();
  const authenticated = user?.authenticated;
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const username = user?.username;

  useEffect(() => {
    window.scrollTo(0, 0);
    if (authenticated) {
    }
  }, []);

  const typeMapping = {
    LIVE: t('define.summary.live'),
    EOCR: t('define.summary.eocr'),
    PCA: t('define.summary.pca'),
  };

  useEffect(() => {
    if (userReportName !== "") {
      setReportName(userReportName);
    }
  }, [userReportName, draftReportId])

  useEffect(() => {
    setReportType(type);
  }, [type])
  const [activeStep, setActiveStep] = React.useState(currentActiveStep);
  const [stepperData, setStepperData] = React.useState("");
  const [reportName, setReportName] = React.useState("Untitled report");
  const [reportType, setReportType] = React.useState("");
  const [editing, setEditing] = React.useState(false);
  const steps = getSteps();

  const handleClick = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  function getSteps() {
    return [
      {
        "title": t('define.report.stepper.title1'),
        "discription": t('define.report.stepper.discription1')
      },
      {
        "title": t('define.report.stepper.title2'),
        "discription": t('define.report.stepper.discription2')
      },
      {
        "title": t('define.report.stepper.title3'),
        "discription": t('define.report.stepper.discription3')
      },
      {
        "title": t('define.report.stepper.title4'),
        "discription": t('define.report.stepper.discription4')
      },
      {
        "title": t('define.report.stepper.title5'),
        "discription": t('define.report.stepper.discription5')
      }
    ];
  }

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <ChooseReportType activeStep={activeStep} setActiveStep={setActiveStep} stepperData={stepperData} setStepperData={setStepperData} />
        );
      case 1:
        return (
          <ChooseReportCampaigns activeStep={activeStep} setActiveStep={setActiveStep} stepperData={stepperData} setStepperData={setStepperData} draftReportId={draftReportId} />
        );
      case 2:
        return (
          <div className={'step-' + step}>
            <ReportMetrics activeStep={activeStep} setActiveStep={setActiveStep} stepperData={stepperData} setStepperData={setStepperData} draftReportId={draftReportId} />
          </div>
        );
      case 3:
        return (
          <div className={'step-' + step}>
            <ReportBreakdownTable activeStep={activeStep} setActiveStep={setActiveStep} stepperData={stepperData} setStepperData={setStepperData} draftReportId={draftReportId} />

          </div>
        );
      case 4:
        return (
          <div className={'step-' + step}>
            <ReportSummary activeStep={activeStep} setActiveStep={setActiveStep} stepperData={stepperData} setStepperData={setStepperData} draftReportId={draftReportId} />
          </div>
        );
      default:
        return 'Unknown step';
    }
  }

  const ColorlibStepIconRoot = styled('div')(({ theme, ownerstate }) => ({
    display: 'flex',
    ...(ownerstate.active && {
      backgroundImage:
        '',
    }),
    ...(ownerstate.completed && {
      backgroundImage:
        'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
    }),
  }));

  function ColorlibStepIcon(props) {
    const { active, className } = props;

    const icons = [
      <StepperBlueIcon />,
      <StepperBlueUnfilledIcon />,
      <StepperGroupIcon />
    ];

    return (
      <ColorlibStepIconRoot ownerstate={{ active }} className={className}>
        {icons[props.active ? 0 : props.completed ? 2 : 1]}
      </ColorlibStepIconRoot>
    );
  }

  const handleChange = e => {
    e.preventDefault();
    setReportName("");
    setReportName(e.target.value);
  }

  const handleEditState = editValue => {
    if (editValue === "edit") {
      setEditing(true);
    } else {
      if (reportName && reportName !== "") {
        setUser(prevUser => ({
          ...user,
          "reportName": reportName
        }));
        setEditing(false);
      }
    }
  }

  return (
    <div className="define-report-container">
      <div className='header-define-report'>
        <h2 className='h2-define-report'>{t('define.report.stepper.header')}</h2>
        <div className="input-container">
          <p className='draft-label'>{ reportType ? typeMapping[reportType] + '  ': ''}{t('define.report.stepper.input.label')}</p>
          <input className='edit-report'
            name="report-name"
            fieldType="report-name"
            defaultValue={reportName}
            value={reportName}
            onChange={handleChange}
            disabled={!editing}
          />
          {
            editing ? <Button className='edit-report-btn'
              appearance="link"
              onClick={() => handleEditState("save")}
            > <SaveIcon /> </Button>
              : <Button className='edit-report-btn'
                appearance="link"
                onClick={() => handleEditState("edit")}
              > <EditIcon /> </Button>
          }
        </div>
      </div>
      <div className='report-stepper-container'>
        <div className='stepper-container'>
          <div className='line'></div>
          <Stepper className='define-report-stepper' activeStep={activeStep} orientation="vertical">
            {steps.map((label, index) => (
              <Step key={index}>
                <StepLabel StepIconComponent={ColorlibStepIcon}><span className='h3-define-report'>{label.title}</span></StepLabel>
                <StepLabel className='define-discription'><span className='p-define-report'>{label.discription}</span></StepLabel>
              </Step>
            ))}
          </Stepper>
        </div>
        <div className='stepper-right-container'>
          {getStepContent(activeStep)}
        </div>
      </div>
    </div>
  );
}

export default DefineReportData;
